export default [
    {
        field: 'hr_previred_ips_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'IPS',
        },
        //value: 30,
        options: {
            data: [],
            text: 'description',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'quotation_rate',
        type: 'text',
        vuetifyProps: {
            label: 'Tasa de cotización',
        },
        rules: ['required'],
        value: '',
    },
]
